"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfraService = void 0;
const request_1 = require("../core/request");
class InfraService {
    /**
     * 验证电话信息
     * 验证电话号码，成功返回
     * - 电话可用状态: 用于判断下步流程
     *
     * @param phone 联系电话
     * @returns any
     * @throws ApiError
     */
    static async checkPhone(phone) {
        const result = await (0, request_1.request)({
            method: 'PATCH',
            path: `/phones/${phone}/check`,
        });
        return result.body;
    }
    /**
     * 发送验证码
     * 发送验证码，基于 type 区分用途\
     * 支持 登录，注册，绑定新手机
     *
     * @param phone 联系电话
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async createPhoneCaptcha(phone, requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/phones/${phone}/captchas`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 新建访问令牌，用于用户登录
     * @param phone 联系电话
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async createPhoneToken(phone, requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/phones/${phone}/tokens`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 用户注册
     * @param phone 联系电话
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async createPhoneUser(phone, requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/phones/${phone}/users`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 用户一键登录
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async createUserByOneclick(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/phones/oneclick`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 通过手机验证码重置密码
     * 通过手机验证码重置用户密码
     *
     * @param phone 联系电话
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async resetUserPasswordByPhone(phone, requestBody) {
        const result = await (0, request_1.request)({
            method: 'PATCH',
            path: `/phones/${phone}/password/reset`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取用户公开信息
     * 仅返回昵称/头像/创建时间
     *
     * @param phone 联系电话
     * @returns any
     * @throws ApiError
     */
    static async phonePublicData(phone) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/phones/${phone}/publicData`,
        });
        return result.body;
    }
    /**
     * 验证邮箱是否注册
     * 验证邮箱是否注册，成功返回
     *
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async checkEmail(requestBody) {
        const result = await (0, request_1.request)({
            method: 'PATCH',
            path: `/emails/check`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 发送邮箱验证码
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async emailCaptcha(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/emails/captchas`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 通过邮箱验证码重置密码
     * 通过邮箱验证码重置用户密码
     *
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async resetUserPasswordByEmail(requestBody) {
        const result = await (0, request_1.request)({
            method: 'PATCH',
            path: `/emails/password/reset`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取用户信息
     * @returns any
     * @throws ApiError
     */
    static async getMyUserInfo() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/users/me`,
        });
        return result.body;
    }
    /**
     * 获取用户信息
     * @param user 用户 uuid
     * @returns any
     * @throws ApiError
     */
    static async getUser(user) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/users/${user}`,
        });
        return result.body;
    }
    /**
     * 更新用户信息
     * @param user 用户 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async updateUser(user, requestBody) {
        const result = await (0, request_1.request)({
            method: 'PUT',
            path: `/users/${user}`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 注销用户
     * @param user 用户 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async removeUser(user, requestBody) {
        const result = await (0, request_1.request)({
            method: 'DELETE',
            path: `/users/${user}`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取用户套餐配置
     * @param user 用户 uuid
     * @returns any
     * @throws ApiError
     */
    static async getUserPlanConfig(user) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/users/${user}/plans/config`,
        });
        return result.body;
    }
    /**
     * 完善用户信息
     * @param user 用户 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async completeUser(user, requestBody) {
        const result = await (0, request_1.request)({
            method: 'PATCH',
            path: `/users/${user}/complete`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 退出登录
     * @param user 用户 uuid
     * @returns any
     * @throws ApiError
     */
    static async logoutUser(user) {
        const result = await (0, request_1.request)({
            method: 'PATCH',
            path: `/users/${user}/logout`,
        });
        return result.body;
    }
    /**
     * 用户注册
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async usersRegister(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/users/signup`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * buildin用户注册
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async buildinUsersRegister(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/users/buildinSignup`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 用户注册
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async usersRegister2(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/users/signup2`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 小程序用户注册
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async wxMiniSignUp(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/users/wxminiSignup`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 使用用户名密码登录
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async loginPassword(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/users/login/password`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 使用验证码登录
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async loginCaptcha(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/users/login/captchas`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 使用第三方授权码登录
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async loginAuthorizationCode(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/users/login/authorization/code`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取微信公众号扫码登录二维码
     * @returns any
     * @throws ApiError
     */
    static async getUserLoginWechatQrcode() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/users/login/wechat/qrcode`,
        });
        return result.body;
    }
    /**
     * 更新推送服务token
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async updateFcmToken(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/users/updateFcmToken`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 领取分销优惠券
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async claimExclusiveCoupon(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/users/claimExclusiveCoupon`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 签约或解约分销联盟
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async signDistributionAlliance(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/users/signDistributionAlliance`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 查询签约状态
     * @returns any
     * @throws ApiError
     */
    static async distributionAllianceStatus() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/users/distributionAllianceStatus`,
        });
        return result.body;
    }
    /**
     * 积分商城兑换
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async integralExchange(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/shop/integralExchange`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 查询积分商城兑换
     * @param page 页码，从 1 开始
     * @param perPage 一页记录数
     * @param uid 用户的id
     * @returns any
     * @throws ApiError
     */
    static async exchangeRecordList(page, perPage, uid) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/shop/exchangeRecordList`,
            query: {
                'page': page,
                'perPage': perPage,
                'uid': uid,
            },
        });
        return result.body;
    }
    /**
     * 获取微信小程序码
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async createMiniProgramQr(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/wechat/createMiniProgramQr`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 长链换短链
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async createShortUrl(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/wechat/createShortUrl`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 短链查长链
     * @param shortCode shortCode不包含https://dwz.cn/
     * @returns any
     * @throws ApiError
     */
    static async getLongUrl(shortCode) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/wechat/getLongUrl`,
            query: {
                'shortCode': shortCode,
            },
        });
        return result.body;
    }
    /**
     * 重置密码
     * 通过老密码, 重置用户密码
     *
     * @param user 用户 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async resetUserPassword(user, requestBody) {
        const result = await (0, request_1.request)({
            method: 'PATCH',
            path: `/users/${user}/password`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 更换新手机
     * 创建新手机，签发新访问令牌
     *
     * @param user 用户 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async updateUserPhone(user, requestBody) {
        const result = await (0, request_1.request)({
            method: 'PATCH',
            path: `/users/${user}/phone`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 绑定第三方账号
     * @param user 用户 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async bindThirdAccount(user, requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/users/${user}/bindAuthorizationCode`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 换绑手机号
     * @param user 用户 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async changeBindPhone(user, requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/users/${user}/changeBindPhone`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 换绑邮箱
     * @param user 用户 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async changeBindEmail(user, requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/users/${user}/changeBindEmail`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 解绑账户信息
     * 解绑账户信息, 手机号不能解绑
     *
     * @param user 用户 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async unbindAccount(user, requestBody) {
        const result = await (0, request_1.request)({
            method: 'PATCH',
            path: `/users/${user}/unbind`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取 用户个性化设置
     * 获取 用户个性化设置, 比如是否打开过某个活动弹窗
     *
     * @param user 用户 uuid
     * @returns any
     * @throws ApiError
     */
    static async getSetting(user) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/users/${user}/setting`,
        });
        return result.body;
    }
    /**
     * 更新用户个性化设置
     * 获取 用户个性化设置, 比如是否打开过某个活动弹窗
     *
     * @param user 用户 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async updateUserSetting(user, requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/users/${user}/setting`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取获取用户是否显示广告
     * 获取获取用户是否显示广告
     *
     * @param user 用户 uuid
     * @param os 系统类型 0 Android, 1 iOS
     * @returns any
     * @throws ApiError
     */
    static async getUserExternal(user, os) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/users/${user}/external`,
            query: {
                'os': os,
            },
        });
        return result.body;
    }
    /**
     * 获取 Email 授权
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async emailAuthorization(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/users/authorization/email`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取 Apple 授权
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async appleAuthorization(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/users/authorization/apple`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取 Apple 授权
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async appleAuthorizationV2(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/users/authorization/apple/v2`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取 Google 授权
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async googleAuthorization(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/users/authorization/google`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取微信授权
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async wechatAuthorization(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/users/authorization/wechat`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取微信openId
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async getWechatOpenId(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/users/authorization/getWechatOpenId`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取微信公众号扫码授权
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async wechatAuthorizationScan(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/users/authorization/wechat/scan`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取 QQ 授权
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async qqAuthorization(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/users/authorization/qq`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取手机号授权, 目前适用于换绑手机号
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async phoneAuthorization(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/users/authorization/phone`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 使用用户ID和密码获取授权, 目前适用于换绑手机号
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async passwordAuthorization(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/users/authorization/password`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 网易易盾验证码校验
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async yidunCaptchaVerify(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/users/yidun/captcha/verify`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取用户空间列表
     * 获取用户空间列表，用于切换用户空间
     *
     * @param user 用户 uuid
     * @returns any
     * @throws ApiError
     */
    static async getUserSpaces(user) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/users/${user}/spaces`,
        });
        return result.body;
    }
    /**
     * 创建用户空间
     * @param user 用户 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async createUserSpace(user, requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/users/${user}/spaces`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取用户信息(与普通的获取用户信息不同，这里不会返回403)
     * @param user 用户 uuid
     * @returns any
     * @throws ApiError
     */
    static async getSharePageUser(user) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/share/users/${user}`,
        });
        return result.body;
    }
    /**
     * 获取用户信息
     * @param code 用户邀请码
     * @returns any
     * @throws ApiError
     */
    static async getUserByCode(code) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/share/users/getUserByCode`,
            query: {
                'code': code,
            },
        });
        return result.body;
    }
    /**
     * 获取用户根信息
     * 获取用户根信息（包括用户信息，space信息，spaceView信息）
     *
     * @param user 用户 uuid
     * @returns any
     * @throws ApiError
     */
    static async getUserRoot(user) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/users/${user}/root`,
        });
        return result.body;
    }
    /**
     * 获取小组拉新活动记录
     * 获取小组拉新活动记录
     *
     * @param user 用户 uuid
     * @returns any
     * @throws ApiError
     */
    static async getUserAcquisitionTeamRecords(user) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/users/${user}/newUserAcquisitionTeamRecords`,
        });
        return result.body;
    }
    /**
     * 获取用户职业列表
     * 获取用户职业列表
     *
     * @returns any
     * @throws ApiError
     */
    static async getUserOccupations() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/users/occupations`,
        });
        return result.body;
    }
    /**
     * 获取空间信息
     * @param space 空间 uuid
     * @returns any
     * @throws ApiError
     */
    static async getSpace(space) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}`,
        });
        return result.body;
    }
    /**
     * 更新空间信息
     * 更新空间信息，只有 owner 可以更新
     *
     * @param space 空间 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async updateSpace(space, requestBody) {
        const result = await (0, request_1.request)({
            method: 'PUT',
            path: `/spaces/${space}`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 删除空间
     * 删除用户空间，只有 owner 可以删除
     *
     * @param space 空间 uuid
     * @returns any
     * @throws ApiError
     */
    static async deleteSpace(space) {
        const result = await (0, request_1.request)({
            method: 'DELETE',
            path: `/spaces/${space}`,
        });
        return result.body;
    }
    /**
     * 获取空间根信息
     * @param space 空间 uuid
     * @returns any
     * @throws ApiError
     */
    static async getSpaceRoot(space) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/root`,
        });
        return result.body;
    }
    /**
     * 获取空间邀请信息
     * @param space 空间 uuid
     * @returns any
     * @throws ApiError
     */
    static async getSpaceInvitation(space) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/invitation`,
        });
        return result.body;
    }
    /**
     * 获取空间块数量
     * @param space 空间 uuid
     * @returns any
     * @throws ApiError
     */
    static async getSpaceBlockCount(space) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/blockCount`,
        });
        return result.body;
    }
    /**
     * 重置空间邀请信息
     * @param space 空间 uuid
     * @returns any
     * @throws ApiError
     */
    static async resetSpaceInvitation(space) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/spaces/${space}/invitation/reset`,
        });
        return result.body;
    }
    /**
     * 获取用户分享页列表
     * @param space 空间 uuid
     * @returns any recordMap 内包含 blocks，collectionViews，roles
     * @throws ApiError
     */
    static async getSpaceUserSharedPages(space) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/userSharedPages`,
        });
        return result.body;
    }
    /**
     * 获取空间分享页列表
     * @param space 空间 uuid
     * @returns any recordMap 内包含 blocks
     * @throws ApiError
     */
    static async getSpaceSharedPages(space) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/sharedPages`,
        });
        return result.body;
    }
    /**
     * 归档列表
     * 归档列表，用于回收站
     *
     * @param space 空间 uuid
     * @param page 页码，从 1 开始
     * @param perPage 一页记录数
     * @param type 内容类型类型，现只支持传单个类型（page、file）或不传，不传则搜索所有的文件夹和页面
     * @returns any 返回值 data 长度小于 pageSize 的后不再请求
     * @throws ApiError
     */
    static async getSpaceArchives(space, page, perPage, type) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/archives`,
            query: {
                'page': page,
                'perPage': perPage,
                'type': type,
            },
        });
        return result.body;
    }
    /**
     * 回收站列表新接口
     * 回收站列表
     *
     * @param space 空间 uuid
     * @param page 页码，从 1 开始
     * @param perPage 一页记录数
     * @param type 内容类型类型，现只支持传单个类型（page、file）或不传，不传则搜索所有的文件夹和页面
     * @returns any 返回值 data 长度小于 pageSize 的后不再请求
     * @throws ApiError
     */
    static async getSpaceTrash(space, page, perPage, type) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/trash`,
            query: {
                'page': page,
                'perPage': perPage,
                'type': type,
            },
        });
        return result.body;
    }
    /**
     * 获取空间内资源列表, 按大小从大到小
     * 获取空间内资源列表
     *
     * @param space 空间 uuid
     * @param page 页码，从 1 开始
     * @param perPage 一页记录数
     * @returns any
     * @throws ApiError
     */
    static async getResourcesList(space, page, perPage) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/resources`,
            query: {
                'page': page,
                'perPage': perPage,
            },
        });
        return result.body;
    }
    /**
     * 空间初始化
     * @param space 空间 uuid
     * @param platform 平台，不传根据请求头判断，根据请求头只区分桌面端和移动端，不区分touch
     * @returns any
     * @throws ApiError
     */
    static async initSpacePage(space, platform) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/spaces/${space}/init`,
            query: {
                'platform': platform,
            },
        });
        return result.body;
    }
    /**
     * 清空空间回收站
     * @param space 空间 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async clearTrash(space, requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/spaces/${space}/clearTrash`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取空间成员列表
     * @param space 空间 uuid
     * @returns any
     * @throws ApiError
     */
    static async getSpaceMembers(space) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/members`,
        });
        return result.body;
    }
    /**
     * 设置空间成员权限
     * @param space 空间 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async setSpaceMemberRole(space, requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/spaces/${space}/members`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 添加空间成员权限
     * @param space 空间 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async addSpaceMember(space, requestBody) {
        const result = await (0, request_1.request)({
            method: 'PUT',
            path: `/spaces/${space}/members`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 空间删除成员
     * @param space 空间 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async removeSpaceMembers(space, requestBody) {
        const result = await (0, request_1.request)({
            method: 'DELETE',
            path: `/spaces/${space}/members`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 添加空间成员 (批量)
     * @param space 空间 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async setSpaceMemberRoleBatch(space, requestBody) {
        const result = await (0, request_1.request)({
            method: 'PUT',
            path: `/spaces/${space}/members/batch`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 添加空间用户备注
     * @param space 空间 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async addSpaceUserRemark(space, requestBody) {
        const result = await (0, request_1.request)({
            method: 'PUT',
            path: `/spaces/${space}/user/remark`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取分享页收入明细
     * @param space 空间 uuid
     * @param page 页码，从 1 开始
     * @param perPage 一页记录数
     * @returns any
     * @throws ApiError
     */
    static async getSharePaidRecords(space, page, perPage) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/sharePaidRecords`,
            query: {
                'page': page,
                'perPage': perPage,
            },
        });
        return result.body;
    }
    /**
     * 获取分享页收入明细
     * @param page 页码，从 1 开始
     * @param perPage 一页记录数
     * @returns any
     * @throws ApiError
     */
    static async distributionAllianceVipPayRecords(page, perPage) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/users/distributionAllianceVipPayRecords`,
            query: {
                'page': page,
                'perPage': perPage,
            },
        });
        return result.body;
    }
    /**
     * 获取分销联盟明细
     * @param page 页码，从 1 开始
     * @param perPage 一页记录数
     * @param from 0 分享页面付费, 1 分销联盟会员付费分佣 2 所有类型
     * @returns any
     * @throws ApiError
     */
    static async distributionAlliancePayRecords(page, perPage, from) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/users/distributionAlliancePayRecords`,
            query: {
                'page': page,
                'perPage': perPage,
                'from': from,
            },
        });
        return result.body;
    }
    /**
     * 获取空间访客列表
     * @param space 空间 uuid
     * @returns any
     * @throws ApiError
     */
    static async getSpaceGuests(space) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/guests`,
        });
        return result.body;
    }
    /**
     * 空间删除访客
     * @param space 空间 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async removeSpaceGuest(space, requestBody) {
        const result = await (0, request_1.request)({
            method: 'DELETE',
            path: `/spaces/${space}/guests`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取空间订阅信息
     * @param space 空间 uuid
     * @returns any
     * @throws ApiError
     */
    static async getSpaceSubscriptionData(space) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/subscriptionData`,
        });
        return result.body;
    }
    /**
     * 校验用户自定义域名是否占用
     * @param space 空间 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async postSpaceDomainCheck(space, requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/spaces/${space}/domain/check`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取空间机器人信息
     * @param space 空间 uuid
     * @returns any
     * @throws ApiError
     */
    static async getSpaceBots(space) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/bots`,
        });
        return result.body;
    }
    /**
     * 获取空间类型信息
     * @param space 空间 uuid
     * @returns any
     * @throws ApiError
     */
    static async getCurrentPlan(space) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/plan`,
        });
        return result.body;
    }
    /**
     * 获取空间类型信息
     * @returns any
     * @throws ApiError
     */
    static async getSpacePlans() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/plans`,
        });
        return result.body;
    }
    /**
     * 获取创建团队空间选项列表
     * @returns any
     * @throws ApiError
     */
    static async getSpaceCreateOptions() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/createOptions`,
        });
        return result.body;
    }
    /**
     * 校验用户该空间是否在白名单中
     * @param space 空间 uuid
     * @returns any
     * @throws ApiError
     */
    static async postSpaceAiCheck(space) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/ai/check`,
        });
        return result.body;
    }
    /**
     * 获取用户该空间 AI 用量
     * @param space 空间 uuid
     * @returns any
     * @throws ApiError
     */
    static async getSpaceAiUsage(space) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/ai/usage`,
        });
        return result.body;
    }
    /**
     * 获取用户该空间 AI 使用详情
     * @param space 空间 uuid
     * @param page 页码，从 1 开始
     * @param perPage 一页记录数
     * @returns any
     * @throws ApiError
     */
    static async getSpaceAiDetail(space, page, perPage) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/ai/detail`,
            query: {
                'page': page,
                'perPage': perPage,
            },
        });
        return result.body;
    }
    /**
     * 获取空间 AI 成员列表
     * @param space 空间 uuid
     * @returns any
     * @throws ApiError
     */
    static async getSpaceAiMembers(space) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/ai/members`,
        });
        return result.body;
    }
    /**
     * 添加空间 AI 成员
     * @param space 空间 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async postSpaceAiMembers(space, requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/spaces/${space}/ai/members`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 删除空间 AI 成员
     * @param space 空间 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async deleteSpaceAiMembers(space, requestBody) {
        const result = await (0, request_1.request)({
            method: 'DELETE',
            path: `/spaces/${space}/ai/members`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 邀请加入空间信息查询
     * @param invitation 邀请码
     * @returns any
     * @throws ApiError
     */
    static async getInvitationInfo(invitation) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/invitation/${invitation}`,
        });
        return result.body;
    }
    /**
     * 空间通过邀请添加成员
     * @param invitation 邀请码
     * @returns any
     * @throws ApiError
     */
    static async joinSpaceByInvitation(invitation) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/invitation/${invitation}/join`,
        });
        return result.body;
    }
    /**
     * 页面通过邀请添加协作者
     * @param invitation 邀请码
     * @returns any
     * @throws ApiError
     */
    static async joinDocByInvitation(invitation) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/invitation/${invitation}/joinDocAsGuest`,
        });
        return result.body;
    }
    /**
     * 获取页面邀请信息
     * @param invitation 邀请码
     * @returns any
     * @throws ApiError
     */
    static async getInvitationWithId(invitation) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/invitation/${invitation}/pageInvitationInfo`,
        });
        return result.body;
    }
    /**
     * 团队版申请
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async teamSpaceApply(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/spaces/teamApply`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 空间类型切换
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async changeType(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/spaces/changeType`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取空间公开信息
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async getSpacesPublicData(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/spaces/getPublicData`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 通过域名获取空间公开信息
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async getPublicDataByDomain(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/spaces/getPublicDataByDomain`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 删除归档
     * 删除归档，用于彻底删除
     *
     * @param archive 归档 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async deleteArchive(archive, requestBody) {
        const result = await (0, request_1.request)({
            method: 'DELETE',
            path: `/archives/${archive}`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 还原归档
     * @param archive 归档 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async restoreArchive(archive, requestBody) {
        const result = await (0, request_1.request)({
            method: 'PATCH',
            path: `/archives/${archive}/restore`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 搜索文档记录
     * 搜索当前空间的文档
     *
     * @param space 空间 uuid
     * @param requestBody
     * @returns any 返回值 results 长度小于 perPage 的后不再请求
     * @throws ApiError
     */
    static async searchDocs(space, requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/search/${space}/docs`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取页面引用推荐
     * @param space 空间 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async searchReferences(space, requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/search/${space}/references`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 根据 sha256 查 ossName
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async searchResource(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/search/resource`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取鉴权图片地址
     * 用户操作列表，用于实现最近访问
     *
     * @param blockId 块 uuid
     * @param ossName 块 uuid
     * @param imgProcess 图片大小质量
     * @param filename 文件名
     * @returns any
     * @throws ApiError
     */
    static async imageUrl(blockId, ossName, imgProcess, filename) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/images_url/${blockId}/${ossName}`,
            query: {
                'img_process': imgProcess,
                'filename': filename,
            },
        });
        return result.body;
    }
    /**
     * 获取鉴权文件下载地址
     * 文件鉴权相关，用以获取鉴权后的文件下载url
     *
     * @param blockId 块 uuid
     * @param ossName 块 uuid
     * @param filename 文件名
     * @returns any
     * @throws ApiError
     */
    static async downloadUrl(blockId, ossName, filename) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/download_url/${blockId}/${ossName}`,
            query: {
                'filename': filename,
            },
        });
        return result.body;
    }
    /**
     * 获取总积分
     * 获取用户总积分
     *
     * @returns any
     * @throws ApiError
     */
    static async creditBalance() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/users/creditBalance`,
        });
        return result.body;
    }
    /**
     * 获取用户积分信息
     * 获取用户积分信息
     *
     * @returns any
     * @throws ApiError
     */
    static async creditBalanceStatistics() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/users/creditBalance/statistics`,
        });
        return result.body;
    }
    /**
     * 获取用户 AI 奖励信息
     * 获取用户 AI 奖励信息
     * @returns any
     * @throws ApiError
     */
    static async getAiRewards() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/users/aiRewards`,
        });
        return result.body;
    }
    /**
     * 获取积分记录列表
     * 获取积分记录列表
     * @param page 页码，从 1 开始
     * @param perPage 一页记录数
     * @returns any 返回值 data 长度小于 pageSize 的后不再请求
     * @throws ApiError
     */
    static async creditIncomes(page, perPage) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/users/creditIncomes`,
            query: {
                'page': page,
                'perPage': perPage,
            },
        });
        return result.body;
    }
    /**
     * 未登录查询活动（只对需要阶梯兑换的活动有效）
     * @param activity 活动id
     * @returns any
     * @throws ApiError
     */
    static async getNotLoggedActivity(activity) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/users/${activity}/notLogged`,
        });
        return result.body;
    }
    /**
     * 查询用户
     * 查询用户
     * @param phone
     * @param email
     * @returns any 返回用户信息
     * @throws ApiError
     */
    static async findUser(phone, email) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/users/find`,
            query: {
                'phone': phone,
                'email': email,
            },
        });
        return result.body;
    }
    /**
     * 创建临时用户
     * 用以邀请未注册的外部访客
     * @param requestBody
     * @returns any 返回用户信息
     * @throws ApiError
     */
    static async temporary(requestBody) {
        const result = await (0, request_1.request)({
            method: 'PUT',
            path: `/users/temporary`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 创建临时用户 (批量)
     * 用以邀请未注册的外部访客
     * @param requestBody
     * @returns any 返回用户信息
     * @throws ApiError
     */
    static async temporaryBatch(requestBody) {
        const result = await (0, request_1.request)({
            method: 'PUT',
            path: `/users/temporary/batch`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取用户版本，用以 web 更新提醒
     * 获取用户版本，用以 web 更新提醒
     * @param version
     * @returns any 返回用户版本
     * @throws ApiError
     */
    static async getUserWebVersion(version) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/users/webVersion`,
            query: {
                'version': version,
            },
        });
        return result.body;
    }
    /**
     * 判断用户所在空间是否付过费
     * 判断用户所在空间是否付过费
     * @returns any 返回所在空间是否付过费
     * @throws ApiError
     */
    static async getUserIsVip() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/users/vip`,
        });
        return result.body;
    }
    /**
     * 查询是否认证
     * @returns any 返回用户版本
     * @throws ApiError
     */
    static async isAuthentication() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/users/authentication`,
        });
        return result.body;
    }
    /**
     * 认证老师和学生
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async userAuthentication(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/users/authentication`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 查询认证学校和专业列表
     * @returns any 返回认证学校和专业列表
     * @throws ApiError
     */
    static async getSchoolAndMajor() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/authentication/list`,
        });
        return result.body;
    }
    /**
     * 查询活动信息
     * @param activity 活动id
     * @returns any
     * @throws ApiError
     */
    static async getActivityById(activity) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/activity/${activity}`,
        });
        return result.body;
    }
    /**
     * 查询最近一个活动信息
     * @returns any
     * @throws ApiError
     */
    static async getRecentlyActivity() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/activity/recently`,
        });
        return result.body;
    }
    /**
     * 根据条件，查询活动列表
     * @param status 活动状态
     * @param type 活动类型
     * @param spaceId 空间id(获取常驻促销活动需要传空间id)
     * @returns any
     * @throws ApiError
     */
    static async getActivityList(status, type, spaceId) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/activity/list`,
            query: {
                'status': status,
                'type': type,
                'spaceId': spaceId,
            },
        });
        return result.body;
    }
    /**
     * 完成活动
     * @param activity 活动id
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async completedActivity(activity, requestBody) {
        const result = await (0, request_1.request)({
            method: 'PUT',
            path: `/activity/${activity}/completed`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 参与（加）活动
     * @param activity 活动id
     * @returns any
     * @throws ApiError
     */
    static async joinActivity(activity) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/activity/${activity}/join`,
        });
        return result.body;
    }
    /**
     * 查询活动领取和发放状态
     * @param activity 活动id
     * @returns any
     * @throws ApiError
     */
    static async getActivityGiveStatus(activity) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/activity/${activity}/give/status`,
        });
        return result.body;
    }
    /**
     * 用户领取活动积分
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async addActivityAward(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/activity/give`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 查询套餐列表
     * @param type 套餐类型(personal、team、all，默认personal）
     * @param payType 支付类型，支持all
     * @returns any
     * @throws ApiError
     */
    static async getPlanList(type, payType) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/plans/list`,
            query: {
                'type': type,
                'payType': payType,
            },
        });
        return result.body;
    }
    /**
     * 新查询套餐列表
     * @param spaceId 空间id
     * @param type 空间类型(smallTeam/team/all/personal，默认 personal）。即使传all，默认也会按照平台先行过滤掉不需要的套餐，比如安卓/web不需要ios的套餐
     * @param payType 支付类型，即使不传，默认也按照平台先行过滤掉不需要的套餐，比如安卓/web不需要iphonepay的套餐。iphonepay：苹果支付、irpay：积分支付、wxpay：微信支付、alipay：支付宝支付、offline：线下转账
     * @returns any
     * @throws ApiError
     */
    static async getNewPlanList(spaceId, type, payType) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/plans/newList`,
            query: {
                'spaceId': spaceId,
                'type': type,
                'payType': payType,
            },
        });
        return result.body;
    }
    /**
     * 容量套餐列表
     * @param spaceId 空间id
     * @returns any
     * @throws ApiError
     */
    static async capacityPlanList(spaceId) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/plans/capacityPlanList`,
            query: {
                'spaceId': spaceId,
            },
        });
        return result.body;
    }
    /**
     * AI包月套餐列表
     * @param spaceId 空间id
     * @returns any
     * @throws ApiError
     */
    static async aiUsagePlanList(spaceId) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/plans/aiUsagePlanList`,
            query: {
                'spaceId': spaceId,
            },
        });
        return result.body;
    }
    /**
     * chrome插件套餐列表
     * @returns any
     * @throws ApiError
     */
    static async extensionPlanList() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/plans/extensionPlanList`,
        });
        return result.body;
    }
    /**
     * buildin套餐列表
     * @param spaceId 空间id
     * @param type 空间类型(smallTeam/team/all/personal，默认 personal）。即使传all，默认也会按照平台先行过滤掉不需要的套餐，比如安卓/web不需要ios的套餐
     * @returns any
     * @throws ApiError
     */
    static async overseaPlanList(spaceId, type) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/plans/oversea/list`,
            query: {
                'spaceId': spaceId,
                'type': type,
            },
        });
        return result.body;
    }
    /**
     * chrome插件套餐状态
     * @returns any
     * @throws ApiError
     */
    static async extensionPlanStatus() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/plans/extensionPlanStatus`,
        });
        return result.body;
    }
    /**
     * 查询优惠券列表
     * @param planId 套餐id,用于后端过滤优惠券用，必传
     * @param month 购买几个月，年也转换为月
     * @param spaceId 空间id
     * @returns any
     * @throws ApiError
     */
    static async getCouponList(planId, month, spaceId) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/plans/couponList`,
            query: {
                'planId': planId,
                'month': month,
                'spaceId': spaceId,
            },
        });
        return result.body;
    }
    /**
     * 查询某活动的状态
     * @param type 活动类型--readbook
     * @param spaceId 空间id
     * @returns any
     * @throws ApiError
     */
    static async getCouponList1(type, spaceId) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/plans/activityCheck`,
            query: {
                'type': type,
                'spaceId': spaceId,
            },
        });
        return result.body;
    }
    /**
     * 解约自动周期扣款
     * @param spaceId 空间id
     * @returns any
     * @throws ApiError
     */
    static async unSignRenewal(spaceId) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/plans/unSignRenewal`,
            query: {
                'spaceId': spaceId,
            },
        });
        return result.body;
    }
    /**
     * 缩减空间人数
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async changeSpaceVersion(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/plans/changeSpaceVersion`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 查询支付中转信息（目前给支付宝连续付费使用）
     * @param token 获取凭证
     * @param type 支付类型（alipay/wxpay/iphonepay）
     * @returns any
     * @throws ApiError
     */
    static async jumpUrl(token, type) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/callback/jumpUrl`,
            query: {
                'token': token,
                'type': type,
            },
        });
        return result.body;
    }
    /**
     * 查询套餐和计算优惠券后价格
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async getQuote(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/plans/quote`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * H5生成预付订单(方便ios支付隐藏代码，出新接口)
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async createPreApply(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/plans/createPreApply`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 生成容量预付订单
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async createCapacityOrder(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/pays/createCapacityOrder`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 生成AI次数包月预付订单
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async createAiUsageOrder(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/pays/createAiUsageOrder`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 订阅付费
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async createSharePaidOrder(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/pays/createSharePaidOrder`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 生成预付订单
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async createPreOrder(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/pays/createPreOrder`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 生成预付订单
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async createPreOrderV2(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/pays/createPreOrder/v2`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * iphone生成预付订单
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async createIphonePreOrder(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/pays/iphone/createPreOrder`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 校验苹果支付订单
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async checkIphonePay(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/pays/iphone/check`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 校验移动端支付订单
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async checkMobilePay(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/pays/mobile/check`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 查询容量订单列表
     * @param page 页码，从 1 开始
     * @param perPage 一页记录数
     * @param space space的id
     * @returns any
     * @throws ApiError
     */
    static async capacityList(page, perPage, space) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/orders/capacityList`,
            query: {
                'page': page,
                'perPage': perPage,
                'space': space,
            },
        });
        return result.body;
    }
    /**
     * 查询订单列表
     * @param page 页码，从 1 开始
     * @param perPage 一页记录数
     * @param space space的id
     * @param spacePlanType 订单类型
     * @returns any
     * @throws ApiError
     */
    static async getOrderList(page, perPage, space, spacePlanType) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/orders/list`,
            query: {
                'page': page,
                'perPage': perPage,
                'space': space,
                'spacePlanType': spacePlanType,
            },
        });
        return result.body;
    }
    /**
     * 查询提现账单列表
     * @param page 页码，从 1 开始
     * @param perPage 一页记录数
     * @param space space的id
     * @returns any
     * @throws ApiError
     */
    static async getWithdrawOrderList(page, perPage, space) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/orders/withdrawOrderList`,
            query: {
                'page': page,
                'perPage': perPage,
                'space': space,
            },
        });
        return result.body;
    }
    /**
     * 查询提现账单列表
     * @param page 页码，从 1 开始
     * @param perPage 一页记录数
     * @returns any
     * @throws ApiError
     */
    static async withdrawForVipOrderList(page, perPage) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/orders/withdrawForVipOrderList`,
            query: {
                'page': page,
                'perPage': perPage,
            },
        });
        return result.body;
    }
    /**
     * 钱包内信息
     * @param space space的id
     * @returns any
     * @throws ApiError
     */
    static async getTotalInWallet(space) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/orders/totalInWallet`,
            query: {
                'space': space,
            },
        });
        return result.body;
    }
    /**
     * 分销联盟分佣钱包内信息
     * @returns any
     * @throws ApiError
     */
    static async totalDistributionAllianceVipInWallet() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/orders/totalDistributionAllianceVipInWallet`,
        });
        return result.body;
    }
    /**
     * 提现
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async withdrawFromWallet(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/orders/withdrawFromWallet`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 分销联盟会员分佣提现
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async withdrawMoneyForVipFromWallet(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/orders/withdrawMoneyForVipFromWallet`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 取消订单
     * @param order 订单id
     * @returns any
     * @throws ApiError
     */
    static async cancelOrder(order) {
        const result = await (0, request_1.request)({
            method: 'PUT',
            path: `/orders/${order}/cancel`,
        });
        return result.body;
    }
    /**
     * 领取激活码
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async claimActivationCode(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/orders/claimActivationCode`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 查询订单状态
     * @param order 订单id
     * @returns any
     * @throws ApiError
     */
    static async getOrderStatus(order) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/orders/${order}/status`,
        });
        return result.body;
    }
    /**
     * 获取wps处理文档所需token
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async getWpsToken(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/wps/console/getToken`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取新手入门任务的活动配置
     * @returns any
     * @throws ApiError
     */
    static async getNewUserActivityConfig() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/configuration/activity/new/user`,
        });
        return result.body;
    }
    /**
     * 查询空间套餐有效期
     * @param space 空间id
     * @returns any
     * @throws ApiError
     */
    static async getSpacePlan(space) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/validTime`,
        });
        return result.body;
    }
    /**
     * 开屏弹窗信息
     * @param space 空间id
     * @returns any
     * @throws ApiError
     */
    static async launchScreenInfo(space) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/launchScreenInfo`,
        });
        return result.body;
    }
    /**
     * 开屏弹窗信息
     * @param space 空间id
     * @returns any
     * @throws ApiError
     */
    static async launchScreenInfoV2(space) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/v2/launchScreenInfo`,
            query: {
                'space': space,
            },
        });
        return result.body;
    }
    /**
     * 查询分销达人送的优惠券
     * @param space 空间id
     * @param showAll 返回所有未过期分销优惠券
     * @returns any
     * @throws ApiError
     */
    static async exclusiveCouponPopup(space, showAll) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/spaces/${space}/exclusiveCouponPopup`,
            query: {
                'showAll': showAll,
            },
        });
        return result.body;
    }
    /**
     * 获取上传token
     * @param source 取值：spaceIcon、avatar、file、import、public、private，默认file
     * @param uuid 接口返回的UUID，用于token续期（在上传大文件时，超过token有效期时长，用户续期token使用）
     * @returns any
     * @throws ApiError
     */
    static async getUploadToken(source, uuid) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/upload/getToken`,
            query: {
                'source': source,
                'uuid': uuid,
            },
        });
        return result.body;
    }
    /**
     * 文件上传获取token新接口
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async getFileUploadInfo(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/upload/getFileUploadInfo`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * cos文件上传获取token新接口
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async getTcFileUploadInfo(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/upload/getTcFileUploadInfo`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取文件上传s3签名链接
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async getS3FileUploadInfo(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/upload/getS3FileUploadInfo`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * oss上传后上报信息
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async getFileUploadInfo1(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/upload/successFileInfo`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 用户未登录时，获取上传token及相关信息
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async getUnsignedInfo(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/upload/getUnsignedInfo`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 用户未登录时，获取cos上传token及相关信息
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async getTcUnsignedInfo(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/upload/getTcUnsignedInfo`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 海外版s3用户未登录时，获取上传token及相关信息
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async getS3UnsignedInfo(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/upload/getS3UnsignedInfo`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 发送任务到队列
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async enqueueTask(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/enqueueTask`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取任务信息
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async getTasks(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/getTasks`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 查询外部图片链接列表
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async getExternalUrlList(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/covers/externalUrl/list`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 批量获取页面付费信息
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async getPageInfos(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/docs/getPageInfos`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 批量获取页面是否是模板中心
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async checkTemplatePage(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/docs/checkTemplatePage`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取页面邀请信息
     * @param doc 文档 uuid
     * @param role 页面权限角色
     * @returns any
     * @throws ApiError
     */
    static async getDocInvitation(doc, role) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/docs/${doc}/invitation`,
            query: {
                'role': role,
            },
        });
        return result.body;
    }
    /**
     * 重置页面邀请信息
     * @param doc 文档 uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async resetDocInvitation(doc, requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/docs/${doc}/invitation/reset`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 端上行为上报
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async behaviorReport(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/behavior/report`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 删除指定的集成
     * @param integrationId
     * @returns any
     * @throws ApiError
     */
    static async deleteIntegration(integrationId) {
        const result = await (0, request_1.request)({
            method: 'DELETE',
            path: `/integrations/${integrationId}`,
        });
        return result.body;
    }
    /**
     * 获取集成秘钥
     * @param integrationId
     * @returns any
     * @throws ApiError
     */
    static async getIntegrationSecret(integrationId) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/integrations/${integrationId}/secret`,
        });
        return result.body;
    }
    /**
     * 重置集成秘钥
     * @param integrationId
     * @returns any
     * @throws ApiError
     */
    static async resetIntegrationSecret(integrationId) {
        const result = await (0, request_1.request)({
            method: 'PATCH',
            path: `/integrations/${integrationId}/secret`,
        });
        return result.body;
    }
    /**
     * 删除指定的Bot
     * @param botId
     * @returns any
     * @throws ApiError
     */
    static async deleteBot(botId) {
        const result = await (0, request_1.request)({
            method: 'DELETE',
            path: `/bots/${botId}`,
        });
        return result.body;
    }
    /**
     * 获取 bot token
     * @param botId
     * @returns any
     * @throws ApiError
     */
    static async getBotToken(botId) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/bots/${botId}/token`,
        });
        return result.body;
    }
    /**
     * oauth 授权
     * oauth 授权
     *
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async createOauthAuthorizationCode(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/oauth/authorizationCode`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 批量生成 url 接口
     * 批量生成 url 接口
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async createUrls(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/file/create_urls`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取空间下的福利激活码列表
     * 获取空间下的福利激活码列表
     * @param space 空间 uuid
     * @returns any
     * @throws ApiError
     */
    static async getWelfareCodeSpaceList(space) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/welfare/code/${space}/list`,
        });
        return result.body;
    }
    /**
     * 获取用户新增激活码数量
     * 获取用户新增激活码数量
     * @param lastTimestamp 上次请求时间
     * @returns any
     * @throws ApiError
     */
    static async getNewWelfareCodeCount(lastTimestamp) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/welfare/unread`,
            query: {
                'lastTimestamp': lastTimestamp,
            },
        });
        return result.body;
    }
    /**
     * 领取激活码
     * 外部用户领取激活码, 可以是未注册用户
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async welfareReceiveCode(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/welfare/receive`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取激活码信息
     * 获取激活码信息
     * @param code 激活码
     * @returns any
     * @throws ApiError
     */
    static async getWelfareCode(code) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/welfare/code/${code}`,
        });
        return result.body;
    }
    /**
     * 从空间福利里领取福利激活码
     * 从空间福利里领取福利激活码
     * @param code 激活码
     * @returns any
     * @throws ApiError
     */
    static async postWelfareCode(code) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/welfare/code/${code}`,
        });
        return result.body;
    }
    /**
     * 兑换/赠送 福利激活码
     * 兑换/赠送 福利激活码
     * @param code 激活码
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async putWelfareCode(code, requestBody) {
        const result = await (0, request_1.request)({
            method: 'PUT',
            path: `/welfare/code/${code}`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 获取用户福利卡券列表
     * 获取用户福利卡券列表
     * @param space 空间 uuid
     * @returns any
     * @throws ApiError
     */
    static async getWelfareSpaceCardList(space) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/welfare/${space}/card/list`,
        });
        return result.body;
    }
    /**
     * 获取订阅目录
     * @returns any
     * @throws ApiError
     */
    static async getSubscribeList() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/subscribe/list`,
        });
        return result.body;
    }
    /**
     * 获取模板订阅目录
     * @returns any
     * @throws ApiError
     */
    static async listSubscribedTemplates() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/subscribe/listSubscribedTemplates`,
        });
        return result.body;
    }
    /**
     * 添加订阅
     * @param block 文档块(或表单视图或评论) uuid
     * @returns any
     * @throws ApiError
     */
    static async addSubscribe(block) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/subscribe/${block}/add`,
        });
        return result.body;
    }
    /**
     * 取消订阅
     * @param block 文档块(或表单视图或评论) uuid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async cancelSubscribe(block, requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/subscribe/${block}/cancel`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 订阅页面发布更新
     * @param block 文档块(或表单视图或评论) uuid
     * @returns any
     * @throws ApiError
     */
    static async subscribePublishChange(block) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/subscribe/${block}/publishChange`,
        });
        return result.body;
    }
    /**
     * 获取订阅状态
     * @param block 文档块(或表单视图或评论) uuid
     * @returns any
     * @throws ApiError
     */
    static async getSubscribeStatus(block) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/subscribe/${block}/status`,
        });
        return result.body;
    }
    /**
     * 获取分享页订阅用户列表
     * @param block 文档块(或表单视图或评论) uuid
     * @returns any
     * @throws ApiError
     */
    static async getSubscribeUserList(block) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/subscribe/${block}/userList`,
        });
        return result.body;
    }
    /**
     * 获取分享页订阅用户订阅人数
     * @param block 文档块(或表单视图或评论) uuid
     * @returns any
     * @throws ApiError
     */
    static async getSubscribeUserCount(block) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/subscribe/${block}/userCount`,
        });
        return result.body;
    }
    /**
     * 激活归因
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async advertisementActivate(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/advertisement/activate`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 注册归因
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async advertisementRegister(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/advertisement/register`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 支付归因
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async advertisementPaid(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/advertisement/paid`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * 如果页面是知识库页面返回配置的封面
     * @param block 文档块(或表单视图或评论) uuid
     * @returns any
     * @throws ApiError
     */
    static async getKnowledgeCover(block) {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/qa/knowledge/${block}/cover`,
        });
        return result.body;
    }
    /**
     * 获取微信签名
     * 获取微信签名
     * @returns any
     * @throws ApiError
     */
    static async getWechatSign() {
        const result = await (0, request_1.request)({
            method: 'GET',
            path: `/weixin/getWechatSign`,
        });
        return result.body;
    }
    /**
     * 查询优惠券信息
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async getCouponInfos(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/coupon/getInfos`,
            body: requestBody,
        });
        return result.body;
    }
    /**
     * Notion 回调
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    static async notionCallback(requestBody) {
        const result = await (0, request_1.request)({
            method: 'POST',
            path: `/notion/callback`,
            body: requestBody,
        });
        return result.body;
    }
}
exports.InfraService = InfraService;
